export default __webpack_public_path__ + "media/images/mailer/icon_flag-4fcd62b70b083afdb6541cfd1799a343.png";